import React, { useContext } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";

import GeneralPageContext from "../../templates/GeneralPageContext";
import { useCallback } from "react";
import AnchorNavContext from "../../components/AnchorNavigation/AnchorNavContext";

export function useAnchorNavVisibilitySensor(sectionId) {
    const sectionRef = React.createRef();

    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    const { onVisibilityChange } = useContext(AnchorNavContext);
    const VisibilitySensor = useCallback(
        ({ children, partialVisibility }) => {
            if (!sectionId) {
                return <>{children}</>;
            }

            return (
                <ReactVisibilitySensor
                    active={showAnchorNavigation && sectionId}
                    onChange={(isVisible) =>
                        onVisibilityChange(isVisible, sectionId)
                    }
                    partialVisibility={partialVisibility ?? true}
                    // intervalCheck={false}
                    // scrollCheck
                    // scrollDelay={100}
                    offset={{ top: 220, bottom: 220 }}
                    delayedCall
                >
                    {children}
                </ReactVisibilitySensor>
            );
        },
        [showAnchorNavigation, sectionId]
    );

    return {
        sectionRef,
        VisibilitySensor
    };
}
